// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"quote-module--paragraph--2BJEs","regular":"quote-module--regular--14Ne5"};